import { AfterViewInit, Component, inject, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { BucketService, FileNode, FolderNode } from 'src/app/services/bucket/bucket.service';
import { Utente, UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { BucketStoreService } from '../../../bucket-store.service';

@Component({
  selector: 'app-dialog-info-documento',
  standalone: false,

  templateUrl: './dialog-info-documento.component.html',
  styleUrl: './dialog-info-documento.component.scss',
})
export class DialogInfoDocumentoComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  private readonly _store = inject(BucketStoreService);
  public infoUtenteCreazione: Utente | undefined = undefined;

  get nomeUtente() {
    if (this.infoUtenteCreazione) {
      return this.infoUtenteCreazione?.firstName + ' ' + this.infoUtenteCreazione?.lastName;
    } else {
      return '...';
    }
  }

  constructor(
    public dialogRef: MatDialogRef<DialogInfoDocumentoComponent>,
    private readonly _bucketService: BucketService,
    private readonly _utilityService: UtilityService,
    private readonly _utenteService: UtenteService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      fileFolder: FileNode | FolderNode;
    },
  ) {}

  async ngAfterViewInit(): Promise<void> {
    this.infoUtenteCreazione = await this._getInfoUtente();
  }

  hasSottoCartelle = (node: FolderNode) => !!node.folders.length;
  hasFile = (node: FolderNode) => !!node.files.length;

  isFileNode(file: FileNode | FolderNode): file is FileNode {
    return typeof (file as FileNode).extension === 'string';
  }

  onClose() {
    // chiudi dialog
  }

  copiaPercorso() {
    /*  navigator.clipboard.writeText(this.percorso); */
  }
  public getLogoFile(file: FileNode): string {
    return this._bucketService.getLogoFile(file.extension);
  }

  getVisiblePath() {
    if (this.data.fileFolder.path) {
      const parts = this.data.fileFolder.path.split('/');
      return 'home/' + parts.slice(3).join('/');
    }
    return '';
  }

  /**
   * get info utente per visualizzare l'untent creaziuone
   */
  private async _getInfoUtente(): Promise<Utente | undefined> {
    this.spinnerOver.show();
    try {
      const result = await firstValueFrom(
        this._utenteService.getUtente(this.data.fileFolder.idUtenteCreazione),
      );
      return result;
    } catch (error) {
      console.error(error);
      return undefined;
    } finally {
      this.spinnerOver.hide();
    }
  }
}
